import { Link } from "gatsby"
import React from "react"

const Header = () => (
  <header className="py-8" id="home">
    <div className="container flex flex-col justify-between pb-12 md:flex-row">
      <div className="relative z-10 block w-full pb-10 my-auto text-center md:py-10 md:pb-0 md:w-1/2 md:text-left">
        <h1 className="text-6xl font-extrabold">I am Patric</h1>
        <h3 className="text-2xl font-bold">UI/UX Designer</h3>
        <p className="mb-4">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, </p>
        <Link className="btn-cta-alt" to="#about">About me</Link> <Link className="btn-cta" to="/contact">Contact me</Link>
      </div>
      <div className="relative block w-full my-auto md:w-1/2">
        <picture>
            <source srcset={`./pfp.webp`} type="image/webp" />
            <source srcset={`./pfp.png`} type="image/png" /> 
            <img src={`./pfp.png`} alt="NO! THIS IS PATRIC!" className="relative z-10 w-2/3 m-auto md:mr-12 md:ml-auto md:w-1/2" />
        </picture>
        <div className="absolute top-0 right-0 origin-bottom-right transform rotate-45 shadow-2xl box">&nbsp;</div>
      </div>
    </div>
  </header>
)


export default Header
